import { render, staticRenderFns } from "./ModalFormats.vue?vue&type=template&id=4cb27758&scoped=true&"
import script from "./ModalFormats.vue?vue&type=script&lang=js&"
export * from "./ModalFormats.vue?vue&type=script&lang=js&"
import style0 from "./ModalFormats.vue?vue&type=style&index=0&id=4cb27758&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb27758",
  null
  
)

export default component.exports